import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './position-profile-report-line.module.scss';
import { BasicTable } from '../../../assets/common';
import positionProfileApi from '../../../services/positionProfileApi';
import { Spin } from 'antd';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const TABLE_STYLE = {
  headerColor: '#8896A7',
  headerWeight: 700,
  borderRadius: 6,
};

const PositionProfileReportLine = ({ positionCode }) => {
  const [data, setData] = useState({ reporting_to: [], direct_report: [] });
  const [loading, setLoading] = useState(false);

  const getData = useCallback(async () => {
    if (!positionCode) return;
    try {
      setLoading(true);
      const res = await positionProfileApi.getReportingLines(positionCode);
      if (res.status === 200) {
        setData(res.data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [positionCode]);

  const COLUMNS1 = useMemo(
    () => [
      {
        title: 'No',
        width: '10%',
        dataIndex: 'no',
        render: (value) => <span className={styles.textNo}>{value}</span>,
      },
      {
        title: 'Reporting To',
        width: '30%',
        dataIndex: 'position_name',
        render: (value, record) => (
          <Link to={`/position-finder/${record.position_code}`} className={styles.text1}>
            {value || '-'}
          </Link>
        ),
      },
      {
        title: 'Position ID',
        width: '30%',
        dataIndex: 'position_code',
        render: (value) => (
          <Link to={`/position-finder/${value}`} className={styles.text}>
            {value || '-'}
          </Link>
        ),
      },
      {
        title: 'Incumbent Name',
        width: '30%',
        dataIndex: 'supervisor_name',
        render: (value, record) => (
          <Link to={`/profile/${record.staff_id}`} className={styles.text}>
            {value || '-'}
          </Link>
        ),
      },
    ],
    []
  );

  const COLUMNS2 = useMemo(
    () => [
      {
        title: 'No',
        width: '10%',
        dataIndex: 'no',
        render: (value) => <span className={styles.textNo}>{value}</span>,
      },
      {
        title: 'Direct Report(s)',
        width: '30%',
        dataIndex: 'position_name',
        render: (value, record) => (
          <Link to={`/position-finder/${record.position_code}`} className={styles.text1}>
            {value || '-'}
          </Link>
        ),
      },
      {
        title: 'Position ID',
        width: '30%',
        dataIndex: 'position_code',
        render: (value) => (
          <Link to={`/position-finder/${value}`} className={styles.text}>
            {value || '-'}
          </Link>
        ),
      },
      {
        title: 'Incumbent Name',
        width: '30%',
        dataIndex: 'supervisor_name',
        render: (value, record) => (
          <Link to={`/profile/${record.staff_id}`} className={styles.text}>
            {value || '-'}
          </Link>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Spin spinning={loading}>
      <div className={styles.wrapper}>
        <div className={styles.title}>Reporting Line</div>
        <div className={styles.tableContainer}>
          <BasicTable rowKey="no" styles={TABLE_STYLE} dataSource={data.reporting_to} columns={COLUMNS1} pagination={false} />
          <BasicTable rowKey="no" styles={TABLE_STYLE} dataSource={data.direct_report} columns={COLUMNS2} pagination={false} />
        </div>
      </div>
    </Spin>
  );
};

export default PositionProfileReportLine;

PositionProfileReportLine.propTypes = {
  positionCode: PropTypes.string,
};
